import { useTranslation } from 'react-i18next';

import { GPT_BANNER_CONFIG } from '../config';
import { GPTBannerProps } from 'src/EXPERIMENTAL_LIB/gpt/banners';

export const GPTBanner = ({ Icon, title, onClick, gameName }: GPTBannerProps) => {
  const { background, boxShadow, textShadow } = GPT_BANNER_CONFIG[gameName] || {};
  const { t } = useTranslation();

  return (
    <div className="relative h-[44px] w-[200px] cursor-pointer select-none pl-3 1024:h-[58px] 1024:w-[267px] 1024:pl-[17px]">
      {Icon && (
        <Icon
          onClick={onClick}
          className="absolute left-0 top-1/2 z-10 h-10 w-10 -translate-y-1/2 1024:h-[52px] 1024:w-[52px]"
        />
      )}
      <div
        onClick={onClick}
        className="flex h-full w-full items-center justify-stretch gap-2 rounded py-1 pl-9 pr-1 1024:pl-12 1024:pr-2"
        style={{ background, boxShadow }}>
        <p
          className="multi-line-truncate text-base font-semibold leading-[100%] text-[white] 1024:text-2xl flex-1"
          style={{ textShadow }}>
          {title && t(title)}
        </p>
        {/* <div onClick={onClose} className="flex h-9 w-9 min-w-9 items-center justify-center ">
          <CloseIcon className="h-3 w-3" />
        </div> */}
      </div>
    </div>
  );
};
